<div class="corp">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <a class="navbar-brand" href="https://nitropay.com" target="_blank">
            <img src="https://s.nitrocnct.com/np.png" />
        </a>
        <!-- Step 3: Toggle the value of the property when the toggler button is clicked. -->
        <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">&#9776;</button>
        <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
            <div class="navbar-nav me-auto"></div>
            <div class="navbar-nav my-2 my-lg-0">
                <a class="nav-item nav-link" href="javascript:;" (click)="isMenuCollapsed = true; openSupportModal()">
                    <i class="fas fa-question-circle"></i> Support
                </a>
            </div>
        </div>
    </nav>
</div>

<app-toasts></app-toasts>

<router-outlet></router-outlet>

<app-footer></app-footer>
